import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["helloCvContainer", "helloCvCustomization"]

    static values = {
        modalPath: String,
        ctaLabel: String,
    }

    connect() {
        this.#customizeModule()
        this.#loadModule()
        this.#mountModals()
        this.#mountButtons()
    }

    #loadModule() {
        !(function (w, d) {
            let head = d.getElementsByTagName("head")[0]
            let body = d.getElementsByTagName("body")[0]
            let host = "https://module.hellocv.com/"
            let request = new XMLHttpRequest()
            request.addEventListener("load", function () {
                if (4 === this.readyState && 200 === this.status) {
                    try {
                        let response = JSON.parse(this.response)
                        if (!response.entrypoints || !Array.isArray(response.entrypoints)) {
                            console.error("Invalid response structure from HelloCV module")
                            return
                        }
                        response.entrypoints.forEach((element) => {
                            if (element.endsWith(".js")) {
                                const script = d.createElement("script")
                                script.src = host + element
                                body.appendChild(script)
                            } else {
                                const link = d.createElement("link")
                                link.rel = "stylesheet"
                                link.href = host + element
                                head.appendChild(link)
                            }
                        })
                    } catch (error) {
                        console.error("Failed to parse HelloCV module manifest:", error)
                    }
                } else {
                    console.error("Failed to load HelloCV module manifest")
                }
            })
            request.addEventListener("error", function () {
                console.error("Network error loading HelloCV module manifest")
            })
            request.open("GET", host + "asset-manifest.json")
            request.send()
        })(window, document)
    }

    #customizeModule() {
        const customPalette = {
            common: {
                black: "#43425D",
                white: "#FFFFFF",
            },
            primary: {
                main: this.helloCvCustomizationTarget.dataset.primaryColor,
                dark: this.helloCvCustomizationTarget.dataset.primaryColor,
                light: this.helloCvCustomizationTarget.dataset.primaryLightColor,
                contrastText: "#FFFFFF",
            },
            secondary: {
                main: this.helloCvCustomizationTarget.dataset.secondaryColor,
                dark: this.helloCvCustomizationTarget.dataset.secondaryColor,
                light: this.helloCvCustomizationTarget.dataset.secondaryLightColor,
                contrastText: "#000000",
            },
            text: {
                primary: "#202124",
                secondary: "#8896ba",
                disabled: "#DDDDDD",
                hint: "#DDDDDD",
            },
        }

        const customFont = {
            fontFamily: "Lato, OpenSans, Arial, sans-serif",
        }

        const hcvRounded = {
            default: 4,
            inputs: 4,
            buttons: 4,
        }

        sessionStorage.setItem("hcvCustomPalette", JSON.stringify(customPalette))
        sessionStorage.setItem("hcvCustomFont", JSON.stringify(customFont))
        sessionStorage.setItem("hcvRounded", JSON.stringify(hcvRounded))
    }

    #mountButtons() {
        const modalController = this.#getModalController()
        const modalFrame = modalController.frameTarget

        modalFrame.addEventListener("click", () => {
            const file = sessionStorage.getItem("pdfFile")
            const downloadCta = document.getElementById("downloadCv")
            downloadCta.setAttribute("href", file)
            downloadCta.setAttribute("download", "cv.pdf")
        })
    }

    #mountModals() {
        const observer = new MutationObserver((mutations, obs) => {
            const button = document.querySelector("#hcvHeaderGetPdfBtn")
            if (button) {
                button.setAttribute("data-action", "click->modal#openDialog:prevent")
                button.setAttribute("data-modal-src-param", this.modalPathValue)
                button.setAttribute("data-modal-target", "button")
                if (this.ctaLabelValue) {
                    button.innerText = this.ctaLabelValue
                }
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })
    }

    #getModalController() {
        let el = this.element
        while (el) {
            const controller = this.application.getControllerForElementAndIdentifier(el, "modal")
            if (controller) return controller
            el = el.parentElement
        }
        return null
    }
}
